/* ================================================================
   VRK Tech Academy — SITE CONSTANTS
   Edit these values to update your site without touching any
   other file.
================================================================ */

// ── Contact Info ────────────────────────────────────────────────
export const PHONE_DISPLAY  = '+91 89855 42028';   // shown on screen
export const WHATSAPP_NUM   = '918985542028';       // country code + number, no spaces or +
export const EMAIL          = 'vrktechacademy@gmail.com';
export const CITY           = 'Hyderabad, Telangana';

// ── Pricing ─────────────────────────────────────────────────────
export const PRICE_PYTHON   = '₹1,999';
export const PRICE_WEBDEV   = '₹1,999';
export const PRICE_MSOFFICE = '₹1,999';
export const PRICE_COMBO    = '₹3,200';
export const ACTUAL_PRICE_COMBO = '₹4,000';
export const PRICE_SAVINGS  = '₹800';

// Numeric base price per course (used for coupon calculations)
export const COURSE_PRICE_NUM = 1999;

// ── Summer Coupon ────────────────────────────────────────────────
export const SUMMER_COUPON_CODE     = 'VRKSUN50';   // shared on summer promo
export const SUMMER_COUPON_DISCOUNT = 0.5;           // 50% off

// ── Batch Details ───────────────────────────────────────────────
export const BATCH_DURATION = '6–8 Weeks';
export const BATCH_SESSIONS = '3 sessions/week, 90 mins each';
export const BATCH_MODE     = 'Online (Live)';
export const BATCH_SIZE     = '8 students max';

// ── Social / SEO ────────────────────────────────────────────────
export const SITE_NAME      = 'VRK Tech Academy';
export const TAGLINE        = 'Skill · Build · Future';

// ── Helper ──────────────────────────────────────────────────────
export function openWhatsApp(message = 'Hi! I am interested in VRK Tech Academy.') {
  window.open(
    `https://wa.me/${WHATSAPP_NUM}?text=${encodeURIComponent(message)}`,
    '_blank'
  );
}

// Set this to false after summer to hide Summer campaign banners.
export const SHOW_SUMMER_PROMO = true;